<mat-card *ngIf="section" class="section">
  <form [formGroup]="sectionForm">
    <mat-card-header class="section-name">
      <div class="full-width">
        <mat-card-title class="text-disabled-color section-card-title">
          <div class="section-title-prefix">
            <ng-container i18n="General|Contest section term@@general-contest-section-term">Section</ng-container>
            <span *ngIf="section.index;else noSectionIndex">&thinsp;{{section.index}}</span>
            <ng-template #noSectionIndex>
              &nbsp;
              <ng-container i18n="General|No data provided@@general-no-data-provided">[no data]</ng-container>
            </ng-template>
          </div>
          <app-button *ngIf="editMode"
                      icon="delete"
                      class="section-delete-btn"
                      [secondary]="true"
                      [destructive]="true"
                      [disabled]="section.questions.length > 0"
                      (clicked)="delete.emit(section); $event.preventDefault();"></app-button>
        </mat-card-title>
        <mat-card-subtitle class="section-subtitle full-width">
          <form-input [control]="nameField"
                      class="full-width"
                      [class.text-normal-color]="localizeMode"
                      label="Section name:"
                      i18n-label="Contest Tasks Editor|Section name input label@@contest-tasks-editor-section-name-input-label"
                      placeholder="Section name..."
                      i18n-placeholder="Contest Tasks Editor|Section name input placeholder@@contest-tasks-editor-section-name-input-placeholder"
                      [minLength]="2" [maxLength]="128"></form-input>
        </mat-card-subtitle>
      </div>
    </mat-card-header>

    <mat-card-content>
      <contest-question *ngFor="let question of section.questions"
                        [question]="question"
                        [editMode]="editMode"
                        [localizeMode]="localizeMode"
                        [disabled]="disabled"
                        class="question"
                        (edit)="handleQuestionEdit($event)"
                        (delete)="handleQuestionDelete($event)"></contest-question>

      <div *ngIf="editMode">
        <mat-error *ngIf="section.questions.length == 0"
                   i18n="Contest Tasks Editor|Section not enough questions error@@contest-tasks-editor-section-not-enough-questions-error">
          Section should contain at least 1 question
        </mat-error>
      </div>
    </mat-card-content>

    <mat-card-footer class="center-align card-footer">
      <app-button *ngIf="editMode"
                  icon="add"
                  [secondary]="true"
                  (clicked)="addQuestion()"></app-button>
    </mat-card-footer>
  </form>
</mat-card>
